import React, { useMemo } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
import CustomMap from "../../components/CustomMap";

const generateMarkerOptions = (nationalParks) => {
  return (
    (nationalParks?.map(park => {
      if (!park.latitude || !park.longitude)
        return;

      let contentString = "<div style='max-width: 125px;' class='text-center'>" +
        `<a target='_blank' href='${park.url}' style='text-decoration: none !important;'>` +
        "<div class='col-xs-12 space text-center'>" +
        `<img src='${park.image}' loading="lazy" onerror='imageErrorHandler($(this));' class='img-thumbnail lazyload' style='width: 100px; height: 75px;'>` +
        "</div>";
    if (park.name)
        contentString += `<div class='col-xs-12 space text-center'><b>${park.name}</b></div>`;
      contentString += "</a></div>";

      return {
        position: {
          lat: parseFloat(park.latitude),
          lng: parseFloat(park.longitude)
        },
        label: park.name || 'N/A',
        title: park.name || 'N/A',
        infoContent: contentString,
        shadow: 'none',
        zIndex: 10,
      };
    }) ?? []).filter(e => !!e)
  );
};

const render = (status) => {
  return <h4>{status}</h4>;
};

const NationalParksMap = ({ data, position, zoom, center }) => {
  const markerOptions = useMemo(() => {
    return generateMarkerOptions(data);
  }, [data]);

  return (
    <div className={`${position}-map-container`}>
      <Wrapper
        apiKey={"AIzaSyD6b-5FLPmR5JZ_Oua53JEqSh3jTa0QLE8"}
        render={render}
      >
        <CustomMap markerOptions={markerOptions} zoom={zoom} center={center} />
      </Wrapper>
    </div>
  );
};

export default NationalParksMap;